import * as React from "react";
import * as ReactDOM from "react-dom";
import { WidgetLoader, Init } from "bwtk";

export function initialize(config: any, root: string, debug: any) {
    config = Object.assign({}, config, {
        "loader.staticWidgetMappings": {
            "ownership-validation": {
                "factory": () => {
                    return require("ownership-validation");
                },
                "namespace": "Public/OwnershipValidation"
            },
            "public-components": {
                "factory": () => {
                    return require("public-components");
                },
                "namespace": "Public/OwnershipValidation"
            }
        }
    });
    Init(config);
    ReactDOM.render(
        <WidgetLoader widget="ownership-validation"/>,
        document.getElementById(root));
}